<template>
  <!-- prettier-ignore -->
  <div class="ProductDetail">
    <h4 v-text="$props.labels.name" />
    <div class="price">
      {{ getLabel('detail_price', { price: setCurrency() }) }}
      <the-icon
        v-tooltip="offerText"
        art="regular"
        name="circle-info"
      />
    </div>
    <p
      class="description"
      v-html="$props.labels.description"
    />
    <ul class="bullets">
      <li
        v-for="(bullet, index) in $props.labels.bulletPoints"
        :key="index"
        v-text="bullet"
      />
    </ul>
  </div>
</template>

<script setup>
import { computed, inject } from 'vue'

import { currency } from '@/modules/PartnerWidget/helpers/formatters'

import usePartnerWidget from '@/hooks/usePartnerWidget'

// HOOKS
const { getLabel, getOfferText } = usePartnerWidget()

// INIT
const { itemData } = inject('detailProps')
const props = defineProps({
  product: {
    type: Object,
    default: () => ({}),
  },
  labels: {
    type: Object,
    default: () => ({}),
  },
})

// COMPUTED
const offerText = computed(() => {
  return getOfferText(itemData.value.basket.persons, itemData.value.showExampleOfferText)
})

// METHODS
function setCurrency() {
  return currency(props.product.price)
}
</script>

<style>
.ProductDetail {
  position: relative;
  color: var(--on-surface);

  h4 {
    font-size: var(--font-size-regular-xl);
    font-weight: var(--font-weight-regular);
    line-height: var(--line-height-regular-xl);
    margin: 0;
  }

  .price {
    font-size: var(--font-size-regular-xl);
    font-weight: var(--font-weight-regular);
    line-height: var(--line-height-regular-xl);
    text-align: left;

    svg {
      font-size: var(--font-size-regular-md);
      color: var(--Interaction-States-enabled-default);

      .theme-darkgreen & {
        color: var(--Interaction-States-enabled-extended);
      }
    }
  }

  .description {
    margin: var(--fixed-spacing-fix-02) 0;
    font-size: var(--font-size-regular-md);
    line-height: var(--line-height-regular-md);
    letter-spacing: var(--letter-spacing-bold-md);
  }

  .bullets {
    margin: 0;
    font-size: var(--font-size-regular-sm);
    line-height: var(--line-height-regular-sm);
    letter-spacing: var(--letter-spacing-regular-sm);
    padding-left: var(--fixed-spacing-fix-06);
  }

  @media screen and (max-width: 299px) {
    .description {
      font-size: var(--pw-font-size-medium);
    }
  }
}
</style>
